import { render, staticRenderFns } from "./Template4.vue?vue&type=template&id=3df82f81&scoped=true&"
import script from "./Template4.vue?vue&type=script&lang=js&"
export * from "./Template4.vue?vue&type=script&lang=js&"
import style0 from "./Template4.vue?vue&type=style&index=0&id=3df82f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df82f81",
  null
  
)

export default component.exports